export default {
  'National address lookup failed': 'تعذر استرجاع العنوان الوطني',
  'You may upload a National Address Certificate, or continue without it. Our team will review your national address.':
    'يمكنك إرفاق شهادة العنوان الوطني أو المتابعة بدونها. سيقوم فريقنا بمراجعة عنوانك الوطني.',
  'National Address Certificate': 'شهادة العنوان الوطني',
  'National Address Certificate upload failed': 'تعذر رفع شهادة العنوان الوطني. يرجى المحاولة مرة أخرى.',
  // Header
  'Application Number :': 'رقم الطلب :',

  // Review step navigation
  'review.contractReview': 'الاتفاقية',
  contractReview: 'الاتفاقية',

  COMPANY_NOT_ACTIVE: 'رقم السجل التجاري غير موجود في السجلات الرسمية.',
  'Unable to validate your details right now. Please try again later.':
    'تعذر التحقق من بياناتك حاليًا. يرجى المحاولة مرة أخرى لاحقًا.',
  OWNER_NOT_FOUND: 'الهوية غير موجودة ضمن هيكل الشركة.',
  COMPANY_RELATION: 'رقم الهوية او الإقامة غير مرتبط بالمنشأة.',
  MOBILE_VERIFICATION_NOT_OWNER: 'رقم الجوال غير مرتبط برقم الهوية.',
  MOBILE_VERIFICATION_INVALID_NUMBER: 'رقم الجوال غير مسجل تحت الهوية.',
  MOBILE_VERIFICATION_INVALID_ID: 'رقم الجوال غير مسجل تحت الهوية.',
  'ID not found under the company structure.': 'رقم الهوية الوطنية المسجل/ الإقامة  غير مرتبط بالرقم الوطني الموحد',
  'Number not registered under ID.': 'رقم الجوال غير مسجل تحت الهوية.',
  // National ID/Iqama validation messages
  'Please enter numbers only.': 'يرجى إدخال أرقام فقط.',
  'Please enter 10 digits valid ID/Iqama number.': 'يرجى إدخال رقم الهوية أو الإقامة بشكل صحيح.',
  'National ID/Iqama is not associated with the company structure.':
    'رقم الهوية او الإقامة غير مرتبط بالمنشأة.',
  'National ID / Iqama is not associated with the company structure.':
    'رقم الهوية او الإقامة غير مرتبط بالمنشأة.',
  // Mobile number validation messages
  'Please enter a valid mobile number.': 'يرجى إدخال رقم جوال صحيح.',
  'Mobile number is not associated with the provided National ID / Iqama': 'رقم الجوال غير مرتبط برقم الهوية.',
  // Nature of Business validation messages
  'Please enter your business activity.': 'يرجى تحديد نشاط المنشأة.',
  // Authorized signatory messages
  'Please select at least one authorized signatory.': 'يجب اختيار مفوض بالتوقيع واحد على الأقل.',
  'Please upload authorized signatory proof.': 'يرجى إرفاق إثبات المفوض بالتوقيع.',
  // Email and PEP validation messages
  'Please enter your email address.': 'يرجى إدخال البريد الإلكتروني.',
  'Please provide the name of the Politically Exposed Person (PEP).': 'يرجى إدخال اسم الشخص البارز سياسيًا (PEP).',
  // Company Information step
  'Company Information': 'معلومات الشركة',
  'Company CR Number or Unified Number': 'رقم السجل التجاري أو الرقم الموحد',
  'Company Unified Number [7]': 'رقم الشركة الموحد [7]',
  'National ID/Iqama': 'رقم الهوية الوطنية / الإقامة',
  'Mobile Number': 'رقم الجوال',
  'Please make sure your mobile number is linked to your National ID/Iqama. This helps us verify your identity.':
    'تأكد من ربط رقم الجوال بهويتك الوطنية / الإقامة. هذا يساعدنا في التحقق من هويتك.',
  'Initial Information': 'المعلومات الأولية',
  'To activate your account, we’ll need to verify your business details. This takes just a few minutes.':
    'لتفعيل حسابك، نحتاج إلى التحقق من تفاصيل عملك. لن يستغرق ذلك سوى بضع دقائق.',
  'Please share basic details about the company you represent.':
    'يرجى مشاركة التفاصيل الأساسية حول الشركة التي تمثلها.',
  'Date of establishment': 'تاريخ التأسيس',
  'Company legal type': 'النوع القانوني للشركة',
  'Company commercial name': 'الاسم التجاري للشركة',
  'Commercial registration number': 'رقم السجل التجاري',
  'Commercial entity number': 'رقم المنشأة التجارية',
  'License authority': 'جهة الترخيص',
  'Contact Us': 'تواصل معنا',
  'Please Enter a Valid Personal Phone Number': 'يرجى إدخال رقم هاتف شخصي صالح',
  'Please Enter a Valid Personal Identification Number': 'يرجى إدخال رقم هوية شخصي صالح',
  'Please Enter a Valid Company CR Number or Unified Number':
    'يرجى إدخال رقم شركة صالح أو رقم موحد تجاري',
  'License issue date': 'تاريخ إصدار الرخصة',
  'License expiry date': 'تاريخ انتهاء الصلاحية',
  'Tax registration certificate': 'شهادة تسجيل ضريبي',
  'Yes, I have a Tax registration certificate.': 'نعم، لدي شهادة تسجيل ضريبي.',
  'Please upload the Tax registration certificate photo.': 'يرجى إرفاق صورة شهادة التسجيل الضريبي.',
  'Tax registration number': 'الرقم الضريبي',
  'Document data:': 'بيانات المستند:',
  'Passport data:': 'بيانات جواز السفر:',
  'Passport number': 'رقم جواز السفر',
  'Parent company license number': 'رقم رخصة الشركة الأم',
  'Select main company activity': 'حدد النشاط الرئيسي للشركة',
  'I want to change a business address': 'أريد تغيير عنوان العمل',
  'If your address details are incorrect or incomplete, check this box to manually enter the correct information.':
    'إذا كانت تفاصيل عنوانك غير صحيحة أو غير كاملة، ضع علامة في هذا المربع لإدخال المعلومات الصحيحة يدويًا.',
  'Company email': 'البريد الإلكتروني للشركة',
  'Select main business nature category': 'اختر الفئة الرئيسية لطبيعة العمل',
  'Select main business nature': 'اختر طبيعة العمل الرئيسية',
  //
  'Select Products': 'اختر المنتجات',
  'Business Information': 'معلومات العمل التجاري',
  'Business Details': 'تفاصيل النشاط التجاري',
  'Enter your company details.': 'أدخل تفاصيل الشركة',
  'Business Owner': 'مالك النشاط التجاري',
  'Review & Confirm': 'مراجعة وتأكيد',
  'Check and confirm your data.': 'تحقق من بياناتك وقم بتأكيدها.',
  Review: 'مراجعة',

  'Bank Details': 'تفاصيل الحساب البنكي',
  'Company Brand Name': 'اسم العلامة التجارية',
  'Brand Name': 'اسم العلامة التجارية',
  'Company Website': 'موقع الشركة',
  'Nature of Business or Main Line of Business': 'طبيعة النشاط الرئيسي',
  'Please enter your brand name': 'يرجى إدخال اسم العلامة التجارية',
  'Please enter your brand name in english': 'يرجى إدخال اسم العلامة التجارية بالإنجليزية',
  'Please enter your company website.': 'يرجى إدخال الموقع الإلكتروني للمنشأة.',
  'Please enter a valid website URL (e.g., example.com)': 'يرجى إدخال رابط موقع صحيح (مثل: example.com).',
  'Website URL exceeds the maximum allowed length of 255 characters. Please enter a shorter URL.':
    'عنوان URL للموقع يتجاوز الحد الأقصى المسموح به وهو 255 حرفًا. يرجى إدخال عنوان URL أقصر.',
  'Please enter your Nature of Business or Main Line of Business':
    'يرجى إدخال طبيعة النشاط التجاري أو الخط الرئيسي للأعمال',
  // Products Summary keys
  'Products Summary': 'ملخص المنتجات',
  'Product': 'المنتج',
  'No of Products': 'عدد المنتجات',
  'No of Terminals': 'عدد الأجهزة',
  'POS Terminal': 'جهاز نقاط البيع',
  // Business Details Modification — new field labels
  'Merchant Name (English)': 'اسم التاجر (بالإنجليزية)',
  'Merchant Name (Arabic)': 'اسم التاجر (بالعربية)',
  'Store Address (English)': 'عنوان المتجر (بالإنجليزية)',
  'Store Address (Arabic)': 'عنوان المتجر (بالعربية)',
  'Please enter your merchant name in English': 'يرجى إدخال اسم التاجر بالإنجليزية',
  'Please enter your merchant name in Arabic': 'يرجى إدخال اسم التاجر بالعربية',
  'Please enter your company name.': 'يرجى إدخال اسم المنشأة.',
  'Please enter store address in English': 'يرجى إدخال عنوان المتجر بالإنجليزية',
  'Please enter store address in Arabic': 'يرجى إدخال عنوان المتجر بالعربية',
  'Please enter your city': 'يرجى إدخال المدينة',
  'Input should be in English': 'الحروف العربية غير مسموحة',
  'Input should be in Arabic': 'الحروف الإنجليزية غير مسموحة',
  'Company Website URL': 'عنوان موقع الشركة',
  'Select City': 'اختر المدينة',
  'Select': 'اختر',

  'Please enter the company website in the following format:':
    'يُرجى إدخال الموقع الإلكتروني بالصيغة التالية:',
  'https://www.domain.com or https://domain.com': 'https://www.domain.com أو https://domain.com',
  'Please enter the full English address (district and street name). This address will be used for POS device delivery.':
    'يرجى إدخال العنوان الكامل بالإنجليزية (اسم الحي واسم الشارع). سيتم استخدام هذا العنوان لتسليم جهاز نقطة البيع.',
  'Enter your store or brand name (shown on receipts and SMS)': 'أدخل اسم المتجر أو العلامة التجارية (يظهر في الإيصالات والرسائل النصية)',
  '': '',
  'Please enter the full Arabic address (district and street name). This address will be used for POS device delivery.':
    'يرجى إدخال العنوان الكامل بالعربية (اسم الحي واسم الشارع). سيتم استخدام هذا العنوان لتسليم جهاز نقطة البيع.',
  'Please enter a valid tax registration number': 'يرجى إدخال رقم تسجيل ضريبي صحيح',
  'Please select Authorized Signatory Proof': 'يرجى اختيار إثبات التوقيع المعتمد',
  'Please enter your email': 'يرجى إدخال بريدك الإلكتروني',
  'Please enter your mobile number': 'يرجى إدخال رقم الجوال.',
  'Please enter a valid mobile number': 'يرجى إدخال رقم هاتف محمول صحيح',
  'Please provide a Name of PEP': 'يرجى إدخال اسم الشخص ذو المنصب السياسي',
  'Tax Registration Number': 'رقم التسجيل الضريبي',
  '(Optional)': '(اختياري)',
  'Review owner details and disclose roles.': 'راجع تفاصيل المالك ووضح الأدوار.',
  'Owner Details': 'تفاصيل المالك',
  Owner: 'المالك',
  'Government Issued ID': 'الهوية الصادرة من جهة حكومية',
  'This person is an authorized signatory': 'هذا الشخص مفوض بالتوقيع',
  Agreement: 'الاتفاقية',
  Finish: 'إنهاء',
  'Choose from the options below:': 'اختر المنتجات التي تحتاجها من الخيارات أدناه.',
  'Verify Number': ' تحقق الرقم',
  'Enter the code sent to the mobile number ending in':
    ' أدخل رمز الرسالة المرسلة إلى رقم الجوال الذي ينتهى بـ',
  'Start accepting online payments via your website or mobile app.':
    'ابدأ بقبول المدفوعات عبر موقعك أو تطبيقك.',

  'Thank you for your application': 'شكرًا لتقديمك الطلب.',
  "We'll review your submission and get back to you within 1–2 business days.":
    'سنراجع طلبك ونرد عليك خلال يوم إلى يومين عمل.',
  'For support, call our customer services phone number below':
    'للحصول على الدعم، اتصل برقم خدمة العملاء أدناه',

  'Upload the signed agreement in PDF format to complete this step.':
    'ارفع الاتفاقية الموقّعة بصيغة PDF لإكمال هذه الخطوة.',
  'Submit Agreement': 'إرسال الاتفاقية',

  'Please open the Nafath mobile app and approve the request by selecting the number above.':
    'افتح تطبيق نفاذ ووافق على الطلب باختيار الرقم أعلاه.',
  'To submit the contract, please complete the Nafath biometric authentication process. Ensure you have access to the Nafath application and press the “Continue” button below when you are ready to proceed.':
    'لإرسال العقد، يُرجى إكمال عملية التحقق البيومتري عبر نافذ. تأكد من وصولك إلى تطبيق نافذ واضغط على زر "متابعة" أدناه عندما تكون مستعدًا للمتابعة.',
  "Don't have the Nafath app yet?": 'ليس لديك تطبيق نفاذ؟ حمّله من هنا:',
  'Verify Your Identity': 'تحقق من هويتك',
  'Nafath Verification': 'التحقق عبر نفاذ',
  'Application Rejected': 'تم رفض الطلب',
  'An authentication request has been sent to your Nafath mobile app.':
    'تم إرسال طلب التحقق إلى تطبيق نفاذ على هاتفك المحمول.',
  'Selected Products': 'المنتجات المختارة',
  'Application Approved!': 'تمت الموافقة على الطلب',

  'Review and sign the agreement.': 'رفع الاتفاقية الموقّعة',
  'Download and Review': 'حمّل وراجع',
  'Continue to Upload Signed File': 'تابع لرفع الملف الموقّع',
  'Upload Signed Agreement': 'رفع الاتفاقية الموقّعة',
  'Application Approved': 'تمت الموافقة على الطلب',
  'Review Rejected': 'تم رفض المراجعة',

  'Go to Portal': 'انتقل إلى البوابة',
  "You're all set to start accepting payments and growing your business.":
    'أصبحت جاهزًا لبدء قبول المدفوعات وتنمية أعمالك.',
  'Your Account is Now Active!': 'تم تفعيل حسابك الآن.',
  'You have been approved!': 'لقد تمت الموافقة على طلبك!',
  'Your application number.': 'رقم طلبك.',
  'What Happens Next': 'ماذا يحدث بعد ذلك',
  'Have any questions? Feel free to call us at ': 'هل لديك أسئلة؟ لا تتردد في الاتصال بنا على ',
  'Application ID': 'رقم الطلب',

  'Loading your agreement...': 'جارٍ تحميل الاتفاقية...',
  'Generate contract': 'إنشاء العقد',
  'Your agreement is ready!': 'اتفاقيتك جاهزة!',

  'Go to Test Portal': 'انتقل إلى بوابة الاختبار',
  'Who will sign the contract?': 'من سيقوم بتوقيع العقد؟',
  'Select authorised signatory': 'حدد الموقع المعتمد',

  'Verification code': 'رمز التحقق',
  'Get a new code in': 'احصل على رمز جديد في',
  Verify: 'تحقق',
  // Address step
  Address: 'العنوان',
  'This must be the location where you will take payments and where we can reach you.':
    'يجب أن يكون هذا هو الموقع الذي ستتلقى فيه المدفوعات ويمكننا الوصول إليك فيه.',
  Country: 'الدولة',
  Location: 'الموقع',
  'Address line': 'العنوان',
  'P.O. Box': 'صندوق بريد',
  'Office phone number': 'رقم هاتف المكتب',
  'Fax number': 'رقم الفاكس',
  'Additional phone number': 'رقم هاتف إضافي',
  'Additional fax number': 'رقم فاكس إضافي',
  'View location': 'عرض الموقع',
  City: 'مدينة',

  // Managers step
  // stagePayload?.activeStep.stepName
  Manager: 'المدير',
  Managers: 'مدراء',
  'Please review the details of the managers of your company.': 'يرجى مراجعة تفاصيل مديري شركتك.',
  'At least one person must have the authority and proof to act as an authorised signatory for your company.':
    'يجب أن يكون لدى شخص واحد على الأقل السلطة والإثبات للعمل كموقع مخول لشركتك.',
  'At least one shall be selected as authorized signatory':
    'يجب اختيار شخص واحد على الأقل كمفوض بالتوقيع',
  'This person is a Politically Exposed Person (PEP)': 'هذا الشخص هو شخص مكشوف سياسياً (PEP)',
  'This person is authorised signatory': 'هذا الشخص هو موقع مخول',
  'A PEP is an individual who holds a prominent public position or has held one in the recent past, making them susceptible to potential corruption and money laundering risks. PEPs include high-ranking government officials, their immediate family members, and close associates.':
    'الشخص المكشوف سياسياً (PEP) هو فرد يشغل منصباً عاماً بارزاً أو شغله في الماضي القريب، مما يجعله عرضة لمخاطر الفساد المحتملة وغسيل الأموال. يشمل الأشخاص المعرضون سياسياً كبار المسؤولين الحكوميين وأفراد أسرهم المباشرين والمقربين منهم.',
  'ID type': 'نوع الهوية',
  'Document Number': 'رقم الوثيقة',
  'ID number': 'رقم الهوية',

  // Shareholders step
  'Add beneficial owner': 'إضافة مالك مستفيد',
  'Edit beneficial owner': 'تعديل المالك المستفيد',
  'Personal data': 'البيانات الشخصية',
  'First name': 'الاسم الأول',
  'Last name': 'اسم العائلة',
  'Date of birth': 'تاريخ الميلاد',
  Nationality: 'الجنسية',
  'Beneficial owner is a Politically Exposed Person (PEP)':
    'المالك المستفيد هو شخص مكشوف سياسياً (PEP)',
  Passport: 'جواز السفر',
  'Document number': 'رقم الوثيقة',
  'Passport Issue Date': 'تاريخ إصدار الجواز',
  'Files supported: JPG, JPEG, PNG, PDF. Max size {{size}}':
    'الملفات المدعومة: JPG، JPEG، PNG، PDF. الحجم الأقصى: {{size}}.',
  '10 MB': '10 ميجابايت',
  '10MB': '10 ميجابايت',
  'Name of Politically Exposed Person': 'اسم الشخص ذو المنصب السياسي',
  'Please provide the countries, individuals, business activities, goods/services involved (including their use, origin, and destination).':
    'يرجى ذكر الدول أو الأفراد أو الأنشطة التجارية أو السلع والخدمات المعنية (بما في ذلك الاستخدام والمنشأ والوجهة).',
  'e-commerceBenefits':
    'ربط سهل عبر API،  منصات ال  Plugins، صفحة دفع مستضافة، أو SDK للجوال. \n البطاقات، المحافظ الرقمية، وطرق الدفع المحلية.\n تقارير مباشرة، أدوات كشف الاحتيال، وتتبع التسويات. \n بيئة تجريبية للاختبار قبل الإطلاق الفعلي.\n مصمم ليناسب المنشآت الصغيرة والمتوسطة والكبيرة. ',

  // POS service translations — modal content
  'posSubTitle': 'حلول نقاط البيع تدعم تجارتك',
  'posLongDescription':
    'استقبل المدفوعات داخل المتجر بسرعة وأمان وموثوقية عبر حلول نقاط البيع المتطورة من نتورك إنترناشيونال. مصمم خصيصًا للمملكة العربية السعودية، يمكّن جهاز POS التجار من قبول طرق الدفع المحلية والدولية مع توفير رؤية كاملة والتحكم الكامل في المعاملات.',
  'posBenefits':
    'قبول طرق الدفع الرئيسية بما فيها أنظمة البطاقات (مدى، فيزا، ماستركارد، ديسكفر، بطاقات دول مجلس التعاون) والمحافظ الرقمية كـ Apple Pay وSamsung Pay.\nمعالجة مدفوعات سريعة وآمنة داخل المتجر لتجربة دفع سلسة\nمراقبة المعاملات وإعداد التقارير في الوقت الفعلي\nتتبع التسويات والمقاصة بسهولة\nبنية تحتية موثوقة متوافقة مع المتطلبات التنظيمية المحلية (ساما)\nحل قابل للتوسع يدعم تجار التجزئة والمنشآت الصغيرة والمتوسطة والكبيرة في المملكة',

  // Aliases for legacy type = "nGeniusPos" (existing API response)
  'nGeniusPosSubTitle': 'حلول نقاط البيع تدعم تجارتك',
  'nGeniusPosLongDescription':
    'استقبل المدفوعات داخل المتجر بسرعة وأمان وموثوقية عبر حلول نقاط البيع المتطورة من نتورك إنترناشيونال. مصمم خصيصًا للمملكة العربية السعودية، يمكّن جهاز POS التجار من قبول طرق الدفع المحلية والدولية مع توفير رؤية كاملة والتحكم الكامل في المعاملات.',
  'nGeniusPosBenefits':
    'قبول طرق الدفع الرئيسية بما فيها أنظمة البطاقات (مدى، فيزا، ماستركارد، ديسكفر، بطاقات دول مجلس التعاون) والمحافظ الرقمية كـ Apple Pay وSamsung Pay.\nمعالجة مدفوعات سريعة وآمنة داخل المتجر لتجربة دفع سلسة\nمراقبة المعاملات وإعداد التقارير في الوقت الفعلي\nتتبع التسويات والمقاصة بسهولة\nبنية تحتية موثوقة متوافقة مع المتطلبات التنظيمية المحلية (ساما)\nحل قابل للتوسع يدعم تجار التجزئة والمنشآت الصغيرة والمتوسطة والكبيرة في المملكة',


  // POS API field name keys
  'POS.name': 'جهاز نقاط البيع',
  'POS.header': 'جهاز نقاط البيع',
  'POS.short': 'اقبل جميع البطاقات والمحافظ الرئيسية في متجرك',
  'POS.long': 'استقبل المدفوعات داخل المتجر بسرعة وأمان وموثوقية عبر حلول نقاط البيع المتطورة من نتورك إنترناشيونال.',
  'POS.monthlyFee': 'الرسوم الشهرية',
  'POS.setupFee': 'رسوم الإعداد',
  'POS.terminalFee': 'رسوم الجهاز',
  'POS.madaLessThan100': 'معاملات مدى أقل من 100 {SAR}',
  'POS.madaLessThan100.description': 'تنطبق على معاملات مدى أقل من 100 {SAR}',
  'POS.madaEqualOrAbove100': 'معاملات مدى 100 {SAR} أو أكثر',
  'POS.madaEqualOrAbove100.description': 'تنطبق على معاملات مدى 100 {SAR} وما فوق',
  'POS.creditcard': 'بطاقة ائتمانية لكل معاملة',
  'POS.gcc': 'رسوم بطاقات دول مجلس التعاون',
  'POS.minimumUsageFee': 'رسوم الحد الأدنى للاستخدام لكل جهاز',
  'POS.minimumUsageFee.description': 'في حال كانت المبيعات الشهرية أقل من 15,000 ﷼ ريال',
  'POS.fundsTransferFee': 'رسوم تحويل الأموال',
  'POS.vat': 'ضريبة القيمة المضافة',
  'POS.maxTerminals': 'الحد الأقصى للأجهزة',
  'POS.currencyLimit': 'حد العملة',

  // eCommerce fee fields
  'eCommerce.monthlyFee': 'الرسوم الشهرية',
  'eCommerce.setupFee': 'رسوم الإعداد',
  'eCommerce.setupFees': 'رسوم الإعداد',
  'eCommerce.creditcard': 'بطاقة ائتمانية لكل معاملة',
  'eCommerce.fundsTransferFee': 'رسوم تحويل الأموال',
  'eCommerce.mada': 'مدى لكل معاملة',
  'eCommerce.madaFee': 'مدى لكل معاملة',
  'eCommerce.madaPricing': 'مدى (لكل معاملة)',
  'capped at': 'بحد أقصى',
  'Number of Terminals': 'عدد الأجهزة',

  'Max size 10MB': 'الحجم الأقصى: ١٠ ميجابايت.',
  'Authorized Signatory Proof': 'إثبات التفويض بالتوقيع',
  'Authorization Letter': 'خطاب التفويض',
  'Maximum length is 155 characters.': 'الحد الأقصى هو ١٥٥ حرفا.',
  'Passport Expiry Date': 'تاريخ انتهاء الجواز',
  'Personal document': 'الوثيقة الشخصية',
  'Personal Document': 'مستند شخصي',
  'Personal document data:': 'بيانات الوثيقة الشخصية:',
  'Document type': 'نوع الوثيقة',
  'Ownership share': 'حصة الملكية',
  'Please specify ownership share': 'الرجاء تحديد حصة الملكية',
  'Shares, %': 'الأسهم،٪',
  Disclosure: 'الإفصاح',
  'Your Government Issued ID is linked to your passport.': 'هويتك الحكومية مرتبطة بجواز السفر. ',
  'Are you, or a direct family member, or any individual associated with your business, a Politically Exposed Person (PEP)?':
    'هل أنت أو أحد أفراد أسرتك أو أي شخص مرتبط بنشاطك التجاري من الأشخاص ذوي المناصب السياسية (PEP)؟',

  'Do your business activities, owners, or officials have any direct or indirect involvement with, or interests in, any sanctioned countries, territories, or individuals/entities listed on sanctions lists?':
    'هل لدى نشاطك التجاري أو الملاك أو المسؤولين أي ارتباط مباشر أو غير مباشر مع دول أو جهات مدرجة في قوائم العقوبات؟ ',
  'This includes any current operations, offices, financial relationships, or planned engagements that may contravene applicable sanctions regulations.':
    'يشمل ذلك أي عمليات حالية، مكاتب، علاقات مالية، أو خطط قد تخالف اللوائح المتعلقة بالعقوبات.',
  'Main Business Nature': 'طبيعة النشاط الرئيسي',
  'Beneficial owners': 'المالكين المستفيدين',
  'Please have your passport ready to provide its issue and expiry dates.':
    'يرجى تحميل جواز السفر الخاص بك لتقديم تاريخ التسليم والانتهاء.',
  'Because shares are held by a Legal entity as disclosed in the above section, please provide the details of Beneficial owners of the entity.':
    'نظرًا لأن الأسهم مملوكة من قبل كيان قانوني كما هو مبين في القسم أعلاه، يرجى تقديم تفاصيل المالكين المستفيدين للكيان.',
  'Individual Shareholder': 'مساهم فردي',
  'Ownership share:': 'حصة الملكية:',
  'Shares count': 'عدد الأسهم',
  'Full name': 'الاسم الكامل',
  Signatory: 'موقّع',
  PEP: 'شخص مكشوف سياسياً',
  'Legal name': 'الاسم القانوني',
  'CR number / Entity number': 'رقم السجل التجاري / رقم الكيان',
  'Legal Entity shareholder': 'مساهم كيان قانوني',
  'Company license': 'رخصة الشركة',
  'Company legal name': 'الاسم القانوني للشركة',
  'Commercial Registration number': 'رقم السجل التجاري',
  'Entity number': 'رقم الكيان',
  'Review shareholders': 'مراجعة المساهمين',
  'Please review all shareholders of your company.': 'الرجاء مراجعة جميع المساهمين في شركتك.',
  'Individual shareholders': 'المساهمون الأفراد',
  'Legal entity shareholders': 'مساهمو الكيانات القانونية',
  'Country of incorporation': 'بلد التأسيس',
  'In case of complex ownership structure please provide comments and/or schemas that might be relevant.':
    'في حالة تعقيد هيكل الملكية، يرجى تقديم تعليقات و/أو مخططات قد تكون ذات صلة.',
  'Additional Information': 'معلومات إضافية',
  'ADDITIONAL INFORMATION': 'معلومات إضافية',
  'Shareholder Proof Document': 'وثيقة إثبات المساهم',
  MEMORANDUM: 'عقد التأسيس',
  'E-commerce': 'التجارة الإلكترونية',
  'Zero Monthly Fees for the First 3 Months ,Valid until <strong>28 September 2026*</strong>':
    'بدون رسوم شهرية لأول ثلاثة أشهر، ساري حتى <strong>28 سبتمبر 2026*</strong>',
  'Setup One-Time Fee: Free': 'رسوم الإعداد لمرة واحدة: مجانًا',
  'Annual Fee: Free': 'الرسوم السنوية: مجانًا',
  'View more details': 'عرض المزيد من التفاصيل',
  ARTICLES: 'النظام الأساسي',

  'Minutes of board meetings': 'محاضر اجتماعات مجلس الإدارة',
  'Please upload a scan or a photo of Minutes of Board Meetings':
    'يرجى تحميل نسخة مسح ضوئي أو صورة من محاضر اجتماعات مجلس الإدارة',
  'Data of joint-stock companies listed in the financial market':
    'بيانات الشركات المساهمة المدرجة في السوق المالي',
  'Please upload a scan or a photo of Data of joint-stock companies listed in the financial market':
    'يرجى تحميل نسخة مسح ضوئي أو صورة من بيانات الشركات المساهمة المدرجة في السوق المالي',
  Remove: 'إزالة',
  // '0.8% per transaction': '٠.٨% لكل معاملة',
  '1% per transaction': '١% لكل معاملة',
  ' per transaction': ' لكل معاملة',
  '1': '١',
  'Domestic Cards': 'بطاقة مدى',
  'International Cards': 'بطاقات دولية',
  'Fees and Charges': 'الرسوم والتكاليف',
  'View Fees and Charges': 'عرض الرسوم والتكاليف',
  // '2.5% + ': '٢.٥٪ + ',
  '2.4% + ': '٢.٤٪ + ',
  Summary: 'الملخص',
  'Total Amount': 'إجمالي المبلغ',
  eCommerce: 'التجارة الإلكترونية',

  'Company Questionnaire': 'استبيان الشركة',
  'Please share additional information about your business.': 'يرجى تقديم معلومات إضافية حول عملك.',
  'Company information': 'معلومات الشركة',
  'Expected turnover': 'الربح المتوقع',
  Declaration: 'إقرار',
  'Additional documents': 'مستندات إضافية',
  'Sama license': 'رخصة ساما',
  'Please upload the SAMA license photo': 'يرجى إرفاق صورة رخصة ساما',
  'Document number:': 'رقم المستند:',
  'License number': 'رقم الرخصة',
  'AML policy and procedure': 'سياسة وإجراءات مكافحة غسل الأموال',
  'Please upload the AML policy and procedure document':
    'يرجى إرفاق وثيقة سياسة وإجراءات مكافحة غسل الأموال',
  'Compliance Clearance Certificate': 'شهادة خلو المخالفات',
  'Please upload the Compliance Clearance Certificate': 'يرجى إرفاق شهادة خلو المخالفات',
  '*Sanctioned countries – Iran, Syria, Cuba, North Korea, Myanmar (Burma), Crimea (Ukraine) and any other countries/territories as updated time to time by the relevant authorities.':
    '*الدول الخاضعة للعقوبات - إيران، سوريا، كوبا، كوريا الشمالية، ميانمار (بورما)، شبه جزيرة القرم (أوكرانيا) وأي دول/أراضٍ أخرى يتم تحديثها من وقت لآخر من قبل السلطات المعنية.',
  'Company website URL': 'عنوان الموقع الإلكتروني للشركة',
  'Number of employees': 'عدد الموظفين',
  'The reason for applying for payment services': 'سبب التقدم بطلب خدمات الدفع',
  'Do you have any established branch?': 'هل لديك أي فرع قائم؟',
  Yes: 'نعم',
  No: 'لا',
  'Please specify the countries and the locations of your branches':
    'يرجى تحديد الدول ومواقع فروعك',
  'Do you require tokenization?': 'هل تحتاج إلى التجزئة؟',
  'Do you hold any position from the below list of categories?':
    'هل تشغل أي منصب من قائمة الفئات التالية؟',
  'Please provide details:': 'يرجى تقديم التفاصيل:',
  'Enter text here': 'أدخل النص هنا',
  'Indicate at least one Manager, Individual Shareholder or Beneficial Owner as a PEP person.':
    'حدد مديرًا واحدًا على الأقل أو مساهمًا فرديًا أو مالكًا مستفيدًا كشخص مكشوف سياسيًا.',
  'Is your company directly or indirectly owned/managed by a natural person residing in a sanctioned country*?':
    'هل شركتك مملوكة أو مدارة بشكل مباشر أو غير مباشر من قبل شخص طبيعي مقيم في دولة خاضعة للعقوبات؟',
  'Specify the name of the sanctioned countries:': 'حدد اسم الدول الخاضعة للعقوبات:',
  'Does your company perform business / transactions on behalf of a third party?':
    'هل تقوم شركتك بإجراء أعمال / معاملات نيابة عن طرف ثالث؟',
  'Is your company registered or incorporated in a sanctioned country?':
    'هل شركتك مسجلة أو مدمجة في دولة خاضعة للعقوبات؟',
  'Does your company have any subsidiary, branch, office or other presence in a sanctioned country?':
    'هل لشركتك أي فرع أو فرع أو مكتب أو وجود آخر في دولة خاضعة للعقوبات؟',
  'Specify the sanctioned country and nature of business/operations:':
    'حدد الدولة الخاضعة للعقوبات وطبيعة العمل / العمليات:',
  'Does your company own any assets in a sanctioned country?':
    'هل تمتلك شركتك أي أصول في دولة خاضعة للعقوبات؟',
  'Does your company trade with the US or in goods that are US origin or in part contain goods of US origin?':
    'هل تتاجر شركتك مع الولايات المتحدة أو بالبضائع التي هي من أصل أمريكي أو تحتوي جزئيًا على بضائع من أصل أمريكي؟',
  'Does your company maintain any relationship with financial institution in a sanctioned country?':
    'هل لشركتك أي علاقة بمؤسسة مالية في دولة خاضعة للعقوبات؟',
  'Financial performance and projection': 'الأداء المالي والتوقعات',
  'These are the values in SAR of expected financial performance':
    'هذه هي القيم بالريال السعودي للأداء المالي المتوقع',
  'Expected average per transaction': 'المعدل المتوقع لكل معاملة',
  'Expected average per month': 'المعدل المتوقع شهريًا',
  'Expected six-month average credit balance': 'متوسط رصيد الائتمان المتوقع لمدة ستة أشهر',
  'Expected sales value turnover per year': 'متوسط دوران قيمة المبيعات سنويًا',
  'Expected number of transactions': 'عدد المعاملات المتوقع',
  'These are the numbers of expected turnover': 'هذه هي أرقام الدوران المتوقع',
  'Expected monthly transactions': 'المعاملات الشهرية المتوقعة',
  'Expected sales volume turnover per year': 'متوسط دوران حجم المبيعات سنويًا',
  'A natural person who is or has been entrusted with prominent public functions including:':
    'الشخص الطبيعي الذي أوكل إليه أو سبق تكليفه بمهام عامة بارزة بما في ذلك:',
  'a head of state, head of government, minister or deputy or assistant minister;':
    'رئيس دولة، رئيس حكومة، وزير أو نائب وزير أو مساعد وزير؛',
  'a senior government official; ': 'مسؤول حكومي كبير؛ ',
  'a member of parliament;': 'عضو في البرلمان؛',
  'a senior politician;': 'سياسي كبير؛',
  'an important political party official;': 'مسؤول مهم في حزب سياسي؛',
  'a senior judicial official;': 'مسؤول قضائي كبير؛',
  'a member of a court of auditors or the board of a central bank;':
    'عضو في ديوان المحاسبة أو مجلس إدارة البنك المركزي؛',
  'an ambassador, charge d’affaires or other high-ranking officer in a diplomatic service; ':
    'سفير، قائم بالأعمال أو أي ضابط عال المستوى في الخدمة الدبلوماسية؛ ',
  'a high-ranking officer in an armed force;': 'ضابط عال المستوى في قوة مسلحة؛',
  'a senior member of an administrative, management or supervisory body of a state-owned enterprise;':
    'عضو كبير في هيئة إدارية أو إدارية أو رقابية في مؤسسة مملوكة للدولة؛',
  'Any of the following family members of the above, including:':
    'أي من أفراد الأسرة التالية المذكورة أعلاه، بما في ذلك:',
  'a spouse;': 'زوجة؛',
  'a partner considered by national law as equivalent to a spouse;':
    'شريك يعتبره القانون الوطني معادلا للزوج؛',
  'a child': 'طفل.',
  'Add your bank account information.': 'أضف معلومات حسابك البنكي.',
  'Get paid directly to your bank account. We’ll use this IBAN to transfer your earnings securely.':
    'استلم مدفوعاتك مباشرة في حسابك البنكي. سيتم استخدام هذا الآيبان لتحويل أرباحك .',
  'Enter IBAN Number': 'أدخل رقم الآيبان',
  'Please provide proof of your IBAN by uploading a stamped IBAN letter that includes the UN/CR Number and is issued within the last year':
    'يرجى تقديم إثبات الآيبان برفع أحد المستندات التالية.',
  'We couldn’t find an account linked to this IBAN.':
    'لم نتمكن من العثور على حساب مرتبط بهذا الآيبان.',
  'Please upload proof of your IBAN.': 'يرجى رفع إثبات الآيبان.',

  // Bank account step
  'Bank account': 'حساب بنكي',
  'Account for E-commerce': 'حساب للتجارة الإلكترونية',
  'Please upload a scan of stamped IBAN letter.': 'الرجاء إرفاق نسخة من خطاب IBAN مختوم.',
  'Stamped IBAN Letter': 'خطاب آيبان مختوم',
  'Please share bank account details. The account must belong to specified company.':
    'الرجاء مشاركة تفاصيل الحساب المصرفي. يجب أن يكون الحساب ملكًا للشركة المحددة.',
  'Beneficiary full name': 'اسم المستفيد بالكامل',
  'Bank name': 'اسم البنك',

  // Review & submit step
  'Review & Submit': 'مراجعة وارسال',
  'Termination reason': 'سبب الإنهاء',
  'Please select each tab to review the information before submitting the application.':
    'الرجاء تحديد كل علامة تبويب لمراجعة المعلومات قبل تقديم الطلب.',
  'To make changes, go to the appropriate section.': 'لإجراء تغييرات، انتقل إلى القسم المناسب.',
  'Commercial name': 'الاسم التجاري',
  'Company entity number': 'رقم كيان الشركة',
  Email: 'البريد الالكتروني',
  IBAN: 'IBAN',
  Relation: 'علاقة',
  'Submitting application': 'تقديم الطلب',
  'Please make sure that you verified the information in the tabs and representatives selected as authorized signatories have a record in the National Information Center for successful registration on the portal and subsequent confirmation of the signed contract. You will not be able to change the application data after submitting.':
    'الرجاء التحقق من المعلومات في علامات التبويب وأن الممثلين المختارين كموقعين مفوضين لديهم سجل في مركز المعلومات الوطني للتسجيل الناجح على البوابة والتأكيد اللاحق للعقد الموقّع. لن تتمكن من تغيير بيانات التطبيق بعد الإرسال.',
  'Do you want to continue?': 'هل تريد الاستمرار؟',
  Continue: 'متابعة',
  Cancel: 'إلغاء',
  'Correct application data': 'تصحيح بيانات التطبيق',
  'Complete all steps to submit application': 'أكمل جميع الخطوات لتقديم الطلب',
  'Submit application': 'تقديم الطلب',
  'Company details': 'تفاصيل الشركة',
  Shareholders: 'المساهمون',

  'Business Owners': 'مالك النشاط التجاري',
  Name: 'الاسم',
  Mobile: 'الهاتف',
  'This person is identified as authorized signatory.': 'هذا الشخص مفوض بالتوقيع',
  'Learn More': 'آعرف المزيد',
  'Authorized Signatory Details': 'بيانات المفوض بالتوقيع',

  'IBAN Number': 'رقم الآيبان',

  'PERSONAL DOCUMENT': 'وثيقة شخصية',
  'Please, fix application data': 'من فضلك، أصلح بيانات الطلب',
  'Internal warning': 'تحذير داخلي',
  'Something went wrong': 'هناك خطأ ما',
  'Your will able to restart the onboarding process after the application is terminated automatically on the next day. In case of any questions contact <1>Customer support</1>.':
    '<ستتمكن من إعادة تشغيل عملية الإعداد بعد إنهاء التطبيق تلقائيًا في اليوم التالي. في حالة وجود أي أسئلة، اتصل بـ <1>دعم العملاء</1>.',
  'You can’t proceed with this application due to data validation errors.':
    'لا يمكنك متابعة هذا التطبيق بسبب أخطاء في التحقق من صحة البيانات.',
  'Authorised Signatory Proof': 'إثبات التوقيع المعتمد',
  'Select the document type': 'حدد نوع المستند',
  'Company name': 'اسم الشركة',
  'Upload a copy of the Power of Attorney showing this person as an authorised signatory':
    'قم بتحميل نسخة من التوكيل الذي يوضح هذا الشخص باعتباره المفوض بالتوقيع',
  'This person is listed on the Company License as part of the company ownership structure':
    'تم إدراج هذا الشخص في ترخيص الشركة كجزء من هيكل ملكية الشركة',
  "Please correct the authorized signatory’s Phone Number: The provided phone number is invalid according to the National Information Center's data. Ensure the phone number is entered correctly. If you have any questions, please contact <1>Customer support</1>.":
    '<يرجى تصحيح رقم هاتف المفوض بالتوقيع: رقم الهاتف المقدم غير صحيح بحسب بيانات مركز المعلومات الوطني. تأكد من إدخال رقم الهاتف بشكل صحيح. إذا كانت لديك أية أسئلة، فيرجى الاتصال بـ <1>دعم العملاء</1>.',
  "The provided phone number does not match the one listed in the National Information Center's record for the authorised signatory’s document. Change the phone number to the correct one.":
    'رقم الهاتف المقدم لا يتطابق مع الرقم الموجود في سجل مركز المعلومات الوطني الخاص بوثيقة المفوض بالتوقيع. قم بتغيير رقم الهاتف إلى الرقم الصحيح.',

  // PEP Modal
  'Who is a Politically Exposed Person (PEP)?': 'من هو الشخص المعرّض سياسياً (PEP)؟',
  'A PEP is an individual who is or has been entrusted with a prominent public role, including:':
    'الشخص المعرّض سياسياً هو فرد يشغل أو شغل منصباً عاماً بارزاً، بما في ذلك:',
  'Head of state or government, ministers, deputy or assistant ministers':
    'رئيس الدولة أو الحكومة، الوزراء، نواب أو مساعدو الوزراء',
  'Senior government or judicial officials': 'كبار المسؤولين الحكوميين أو القضائيين',
  'Members of parliament or senior politicians': 'أعضاء البرلمان أو كبار السياسيين',
  'Senior officials of political parties': 'كبار مسؤولي الأحزاب السياسية',
  'Members of courts of auditors or central bank boards':
    'أعضاء ديوان المحاسبة أو مجالس البنوك المركزية',
  'Ambassadors or high-ranking diplomats': 'السفراء أو الدبلوماسيون رفيعو المستوى',
  'Senior military officers': 'كبار الضباط العسكريين',
  'Senior executive or supervisory bodies of state-owned enterprises':
    'كبار التنفيذيين أو أعضاء الهيئات الرقابية في الشركات المملوكة للدولة',
  'Also Considered PEPs:': 'يُعتبرون أيضاً أشخاصاً معرّضين سياسياً:',
  'Direct family members, including:': 'أفراد العائلة المباشرين، بما في ذلك:',
  'Spouse or partner (as recognized by law)': 'الزوج أو الشريك (وفقاً لما يعترف به القانون)',
  'Children and their spouses': 'الأبناء وأزواجهم',
  'Parents.': 'الوالدان',
  'Close associates, including:': 'المقرّبون، بما في ذلك:',
  'Individuals with joint ownership or close business ties with the PEP':
    'الأشخاص الذين لديهم ملكية مشتركة أو علاقات عمل وثيقة مع الشخص المعرّض سياسياً',
  'Beneficiaries of entities established for the PEP’s benefit':
    'المستفيدون من الكيانات التي تم إنشاؤها لصالح الشخص المعرّض سياسياً',
  'Note: Family members and close associates of a PEP are also considered PEPs':
    'ملاحظة: يُعتبر أفراد عائلة الشخص المعرّض سياسياً والمقرّبون منه أيضاً أشخاصاً معرّضين سياسياً',
  'Note:': 'ملاحظة:',
  'Family members and close associates of a PEP are also considered PEPs':
    'يُعتبر أفراد عائلة الشخص المعرّض سياسياً والمقرّبون منه أيضاً أشخاصاً معرّضين سياسياً',

  'Sanctioned Countries, Territories and Individuals': 'الدول والأقاليم والأفراد الخاضعون للعقوبات',
  'Sanctioned Countries/Territories:': 'الدول/الأقاليم الخاضعة للعقوبات:',
  "Iran, Syria, Cuba, North Korea (Democratic People's Republic of Korea), Crimea, Sevastopol, Donetsk, Luhansk, and any other regions designated by relevant authorities.":
    'إيران، سوريا، كوبا، كوريا الشمالية (جمهورية كوريا الشعبية الديمقراطية)، القرم، سيفاستوبول، دونيتسك، لوغانسك، وأي مناطق أخرى تحددها الجهات المختصة.',
  'Sanctioned Parties:': 'الأطراف الخاضعة للعقوبات:',
  'Includes individuals or entities listed by the United Nations Security Council, the European Union, the U.S. Office of Foreign Assets Control (OFAC), the UK HMT, or the UAE Supreme Council for National Security (Local Terrorist List).':
    'يشمل الأفراد أو الكيانات المدرجة ضمن قوائم مجلس الأمن التابع للأمم المتحدة، والاتحاد الأوروبي، ومكتب مراقبة الأصول الأجنبية الأمريكي (OFAC)، ووزارة الخزانة البريطانية (HMT)، أو المجلس الأعلى للأمن الوطني في دولة الإمارات العربية المتحدة (قائمة الإرهاب المحلية).',
  'Note:  This list may be updated periodically by the relevant authorities.':
    'ملاحظة: قد يتم تحديث هذه القائمة بشكل دوري من قبل الجهات المختصة.',
  'This list may be updated periodically by the relevant authorities.':
    'قد يتم تحديث هذه القائمة بشكل دوري من قبل الجهات المختصة.',

  Add: 'إضافة',
  Copy: 'نسخ',

  // Agreement Review Section (after contract is loaded)
  'Review your agreement.': 'راجع اتفاقيتك.',
  'Ecom': 'التجارة الإلكترونية',
  'POS': 'أجهزة نقاط البيع',
  'Authorized Signatory details': 'بيانات المفوض بالتوقيع',
  'I confirm that I have read, understood and agree to be bound by Network International\'s Terms & Conditions.':
    'أؤكد أنني قرأت وفهمت وأوافق على الالتزام بشروط وأحكام نتورك إنترناشيونال.',
  'I have read, understood and agreed to the Merchant Terms and Conditions and Privacy Notice':
    ' أقر بأنني قرأت وفهمت وأوافق على الالتزام بالشروط والأحكام الخاصة بنتورك إنترناشيونال',
  'Review Terms and Conditions': 'مراجعة الشروط والأحكام',
  'I acknowledge that I have read the fees and charges and confirm that I have read and understood its contents prior to submitting this application.':
    'أقر بأنني اطلعت على الرسوم والتكاليف وفهمت محتواها قبل تقديم الطلب',
  'View Fees and charges': 'عرض الرسوم والتكاليف',
  Submit: 'إرسال',
  'Contact us': 'تواصل معنا',

  // Signatory Details modal
  'Merchant Name': 'اسم المتجر',
  'Authorized Name': 'اسم المفوض بالتوقيع',
  'Commercial Registration No.': 'رقم السجل التجاري',
  'Unified Number': 'الرقم الموحد',

  // Terms & Conditions modal
  'Terms & Conditions': 'الشروط والأحكام',
  'Terms and Conditions of Use. Ownership of Network Platform': 'شروط وأحكام الاستخدام. ملكية منصة نتورك',
  'I Agree': 'أوافق',
  'These Terms and Conditions of Use (the "Terms of Use") apply to the Network web site located at www.network.ae, and all associated sites linked to www.network.ae by Network, its subsidiaries and affiliates, including Network sites around the world. Network is the operator of the Network Platform (the "App") call center and other technology platforms (collectively, the "Network Platform"). The Network Platform is the property of Network International LLC ("Network") and/or its licensors.':
    'تسري شروط وأحكام الاستخدام هذه على موقع نتورك الإلكتروني على www.network.ae، وجميع المواقع المرتبطة به من قِبل نتورك وشركاتها التابعة والمنتسبة، بما في ذلك مواقع نتورك حول العالم.',
  'BY USING THE NETWORK PLATFORM, YOU AGREE TO THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE, DO NOT USE THE NETWORK PLATFORM. IF YOU ARE A NETWORK CUSTOMER, THE DEFINITIVE AGREEMENT SIGNED BETWEEN YOU AND NETWORK SHALL ALSO GOVERN THE USAGE OF THE NETWORK PLATFORM.':
    'باستخدامك منصة نتورك، فإنك توافق على هذه الشروط والأحكام. في حال عدم موافقتك، يُرجى عدم استخدام منصة نتورك.',
  "Network reserves the right, at its sole discretion, to change, modify, add or remove portions of these Terms of Use, at any time. It is your responsibility to check these Terms of Use periodically for changes. Your continued use of the Network Platform following the posting of changes will mean that you accept and agree to the changes. As long as you comply with these Terms of Use, Network grants you a personal, non-exclusive, non-transferable, limited privilege to enter and use the Network Platform on your personal device.":
    'تحتفظ نتورك بالحق، وفق تقديرها المطلق، في تعديل أو تغيير أو إضافة أو حذف أجزاء من شروط الاستخدام هذه في أي وقت.',
  'The Network Platform is intended for use only by persons who are residents of, and physically located within, the Kingdom of Saudi Arabia. By using the Network Platform, you represent and warrant that you satisfy this requirement. If you do not satisfy this requirement, please do not use the Network Platform.':
    'منصة نتورك مخصصة حصراً للأشخاص المقيمين داخل المملكة العربية السعودية والمتواجدين فيها جسدياً.',

  // Fees drawer
  'Fees and charges': 'الرسوم والتكاليف',
  'Service Fee': 'رسوم الخدمة',
  Waived: 'معفاة',
  'Fees VAT label': 'ضريبة القيمة المضافة:',
  'All prices are VAT excluded': 'جميع الأسعار غير شاملة ضريبة القيمة المضافة',
  'No fees information available.': 'لا تتوفر معلومات عن الرسوم.',

  Copied: 'تم النسخ',

  // Bank account - file upload error codes
  BAD_PROVIDED_FILE_en: 'Bank Proof Letter format is not supported',
  BAD_PROVIDED_FILE_ar: 'صيغة خطاب إثبات الحساب البنكي غير مدعومة',

  // Error Modal
  'Issue Encountered': 'حدث خطأ',
  'Try Again': 'حاول مجدداً',


  // Start In Minutes
  "Start in minutes": "ابدأ خلال دقائق",
  "Complete your onboarding in a few simple steps, no documents required.": "أكمل عملية التسجيل بخطوات بسيطة، بدون الحاجة لأي مستندات",
  "Steps": "الخطوات",
  "Basic Information": "المعلومات الأساسية",
  "Mobile number, CR, and National ID/Iqama": "رقم الجوال، السجل التجاري، ورقم الهوية/الإقامة",
  "National ID/Iqama and Unified National Number": "الرقم الموحد للمنشأة و رقم الهوية الوطنية / الإقامة",
  "Company Details": "تفاصيل الشركة",
  "Auto-filled from official records": "يتم تعبئتها تلقائيًا من السجلات الرسمية",
  "Bank Details Start": "البيانات البنكية",
  "Add your IBAN securely": "أدخل رقم الآيبان بشكل آمن",
  "Agreement Start": "الاتفاقية",
  "Review and sign digitally": "مراجعة وتوقيع إلكتروني",
  "Identity Verification": "التحقق من الهوية",
  "Secure verification via Nafath": "تحقق آمن عبر نفاذ",
  "All your data is protected in accordance with the highest security standards and regulations adopted in the Kingdom of Saudi Arabia.": "جميع بياناتك محمية وفق أعلى معايير الأمان والأنظمة المعتمدة في السعودية",
  "Start Now": "ابدأ الآن",
  "Something went wrong. Please go back and try again.": "حدث خطأ ما. يرجى العودة والمحاولة مرة أخرى.",
  "Something went wrong. Please try again.": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",

  // Nafath CONFIRMATION step (new design)
  'Verify via Nafath': 'التحقق عبر نفاذ',
  'By continuing, you accept to verify your identity through Nafath services.':
    'بالمتابعة، فإنك توافق على التحقق من هويتك عبر خدمات نفاذ.',

  // DataValidation page — hint & info-box texts
  '10-digit': '10 أرقام',
  'National ID or Iqama number': 'رقم الهوية الوطنية أو الإقامة المكوّن من',
  'Please use a mobile number registered with your National ID/Iqama for faster verification.':
    'يرجى استخدام رقم الجوال المسجل في هويتك الوطنية / الإقامة للتحقق بشكل أسرع.',
  'Unified National Number': 'الرقم الموحد للمنشأة',
  'Please enter a valid 10-digit Unified National Number starting with (7).':
    'الرجاء إدخال الرقم الوطني الموحد المكوّن من 10 أرقام، على أن يبدأ بالرقم (7)',

  // MerchantOnboardingInProgress — completion page
  'Instructions for setting up your selected product/s have been emailed to you.':
    'تم إرسال تعليمات إعداد المنتج/المنتجات المحددة إلى بريدك الإلكتروني.',
  'If we need any additional info, we will contact you within 2 business days.':
    'إذا احتجنا إلى أي معلومات إضافية، سنتواصل معك خلال يومي عمل.',
  '800-4448.': '800-4448.',

  // SmsOtpPage — OTP verification page
  'Invalid OTP': 'رمز التحقق غير صحيح',
  'Please enter SMS OTP': 'يرجى إدخال رمز التحقق المرسل عبر الرسالة النصية',
  'Unable to resend code. Please try again from the beginning.':
    'تعذّر إعادة الإرسال. يرجى المحاولة من البداية.',
  'Verification code has been resent': 'تم إعادة إرسال رمز التحقق',
  'Failed to resend code. Please try again.':
    'فشل إعادة إرسال الرمز. يرجى المحاولة مجددًا.',

  // Service selection page — card names & short descriptions
  'POS terminal': 'جهاز نقاط البيع',
  'E-Commerce': 'التجارة الإلكترونية',

  // E-commerce service details modal
  'e-commerceSubTitle': 'موثوق به من كبار التجار عبر الإنترنت في جميع أنحاء المنطقة.',
  'e-commerceLongDescription':
    'اقبل المدفوعات الآمنة عبر الإنترنت من خلال موقعك أو تطبيقك، سواء كنت تبيع محليًا أو عالميًا.',

  // Alias for nGeniusPos type (same content as pos)
  // Fees & Charges section — title and field names
  'Fees & Charges': 'الرسوم والتكاليف',

  // POS fee field names
  'Setup fee': 'رسوم التأسيس',
  'Monthly fee': 'الرسوم الشهرية',
  'Annual fee': 'الرسوم السنوية',
  'Credit card per transaction': 'بطاقة الائتمان لكل معاملة',
  'Credit card (per transaction)': 'بطاقة الائتمان (لكل معاملة)',
  'GCC Card Fee': 'رسوم بطاقات دول مجلس التعاون',
  'Minimum usage fee per POS device': 'رسوم الحد الأدنى للاستخدام لكل جهاز',
  'Funds transfer fee': 'رسوم تحويل الأموال',
  'Funds Transfer Fees': 'رسوم تحويل الأموال',
  'mada (per transaction)': 'مدى (لكل معاملة)',

  // ApplicationSummary
  Qty: 'الكمية',

  // BankDetails review component
  'Account Holder Name': 'اسم صاحب الحساب',
  'Bank Name': 'اسم البنك',

  // Nafath CONFIRMATION step (new design)  
  'Please open the Nafath mobile app and approve the request by selecting the number below.':
    'افتح تطبيق نفاذ ووافق على طلب التحقق باستخدام الرقم الظاهر أدناه.',
  'Expires in': 'تنتهي الصلاحية خلال',
  'Retry with a New Code': 'إعادة المحاولة برمز جديد',
  'The Nafath biometric authentication retry is temporarily locked. Please wait before trying again.':
    'تم تعليق محاولات التحقق مؤقتًا بسبب عدد المحاولات. يرجى الانتظار ثم إعادة المحاولة.',
  'Try again in': 'حاول مرة أخرى خلال',
  'Try again to complete the authentication in': 'حاول مرة أخرى لإكمال التحقق خلال',
  'Authentication request expired': 'انتهت صلاحية طلب التحقق',
  'The Nafath biometric authentication request was rejected.':
    'تم رفض طلب التحقق البيومتري عبر نفاذ.',
  'You have {{count}} attempts left.': 'لديك {{count}} محاولة متبقية.',
  'Please ensure the provided IBAN number is linked to your commercial registration number.':
    'يرجى التأكد من أن رقم الآيبان المدخل مرتبط برقم السجل التجاري الخاص بك.',

  'Scan to download': 'امسح رمز الاستجابة السريعة لتنزيل التطبيق.',
  'Or copy the link:': 'أو انسخ الرابط:',
  "Download the app here if you don't have it.": 'حمل التطبيق من هنا إذا لم يكن لديك.',

  // Fees & Charges popup — tab labels
  'eCommerce_tab_label': 'التجارة الإلكترونية',
  'POS_tab_label': 'نقاط البيع',

  // Fees & Charges popup — section header
  'Service Fees': 'رسوم الخدمة',
  'Service fees': 'رسوم الخدمة',

  // Fees & Charges popup — fee line labels (API string variants)
  'Setup Fees': 'رسوم التأسيس',
  'Setup Fee': 'رسوم التأسيس',
  'Monthly Fee': 'الرسوم الشهرية',
  'Credit Card (per transaction)': 'البطاقات الائتمانية (لكل عملية)',
  'Funds Transfer Fee': 'رسوم تحويل الأموال',
  'mada less than ﷼100': 'مدى أقل من 100 SAR (لكل عملية)',
  'mada equal or above ﷼100': 'مدى بقيمة 100 SAR أو أكثر',
  'mada less than 100 ﷼': 'مدى أقل من 100 SAR (لكل عملية)',
  'mada equal or above 100 ﷼': 'مدى بقيمة 100 SAR أو أكثر',
  'mada less than ﷼ 100': 'مدى أقل من 100 SAR (لكل عملية)',
  'mada equal or above ﷼ 100': 'مدى بقيمة 100 SAR أو أكثر',
  // Exact API response format (SAR token — replaced with icon by renderTextWithSarIcon)
  'mada less than SAR 100': 'مدى أقل من 100 SAR (لكل عملية)',
  'mada equal SAR 100 or above': 'مدى بقيمة 100 SAR أو أكثر',
  'GCC Card fees': 'رسوم بطاقات دول مجلس التعاون',
  'VAT': 'ضريبة القيمة المضافة',

  // API label strings — SAR token kept so renderTextWithSarIcon replaces it with the icon
  'mada equal or above SAR 100': 'مدى بقيمة 100 SAR أو أكثر',

  // Fees & Charges popup — condition/sub-label strings
  'If the monthly sales value below 15,000 ﷼': '(في حال كانت المبيعات الشهرية أقل من 15,000 SAR ريال)',
  'If the monthly sales value below ﷼ 15,000': '(في حال كانت المبيعات الشهرية أقل من 15,000 SAR ريال)',
  'If the monthly sales value below ﷼15,000': '(في حال كانت المبيعات الشهرية أقل من 15,000 SAR ريال)',

  // Risk Questionnaire step
  'Risk Questionnaire': 'استبيان المخاطر',
  'Provide these answers based on your business': 'يرجى تقديم هذه الإجابات بناءً على نشاطك التجاري.',
  'Expected number of transactions per month': 'العدد المتوقع للمعاملات شهريًا',
  'Please Select': 'الرجاء الاختيار',
  'Expected monthly sales amount ({SAR})': 'قيمة المبيعات الشهرية المتوقعة ({SAR})',
  'Expected average transaction value ({SAR})': 'متوسط قيمة المعاملة المتوقع ({SAR})',
  'Expected annual revenue ({SAR})': 'الإيرادات السنوية المتوقعة ({SAR})',
  'This field is required': 'هذا الحقل مطلوب',
  // Exact API response format (SAR token)
  'If the monthly sales value below SAR 15,000': '(في حال كانت المبيعات الشهرية أقل من 15,000 SAR ريال)',
  'Issue date can not be in the future': 'تاريخ الإصدار لا يمكن أن يكون في المستقبل',
  'Please enter a valid issue date': 'يرجى إدخال تاريخ إصدار صالح',
  'Please enter a valid expiry date': 'يرجى إدخال تاريخ انتهاء صلاحية صالح',
  'Expiry date can not be in the past': 'تاريخ انتهاء الصلاحية لا يمكن أن يكون في الماضي',
  'Maximum 150 characters.': 'الحد الأقصى 150 حرفاً.',
  'The Iban verification failed.': 'فشل التحقق من رقم الآيبان.',
  'Download File': 'تحميل الملف',
};
